import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=f4172340&scoped=true"
import script from "./checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=f4172340&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4172340",
  null
  
)

export default component.exports